import { classNames } from "primereact/utils";
import React, { useEffect, useRef, useState } from "react";
import {
  Link,
  useNavigate,
  useParams
} from "react-router-dom";
import iconImage from "../../assets/icons/icon-image.png";
import ButtonImage from "../../components/Buttons/ButtonImage";
import ButtonZegel from "../../components/Buttons/ButtonZegel";
import DialogImage from "../../components/Dialog/DialogImage";
import DialogZegel from "../../components/Dialog/DialogZegel";
import FooterInterno from "../../components/Footer/FooterInterno";
import DashboardNavBarEvaluacionProgreso from "../../components/Header/DashboardNavBarEvaluacionProgreso";
import {
  DescargarFromBase64,
  buscarConfiguracion,
} from "../../helpers/helpers";
import useAlumno from "../../hooks/useAlumno";
import { PrivateRoutes } from "../../routes/routes";
import { BuscarEvaluacionPorId } from "../../services/EvaluacionService";
import {
  EvaluarExamen,
  ListarPreguntasPorUnidad,
  ObtenerAlternativasPorUnidad,
} from "../../services/PreguntaService";
import { BuscarUnidadID } from "../../services/UnidadService";
import "./styles/EvaluacionExamen.scss";
import "./styles/EvaluacionIntro.scss";

import iconDownload from "../../assets/img/interna/download.png";
import {
  DescargarListaMaterialesUnidad,
  ObtenerListaMaterialesUnidad
} from "../../services/MaterialService";
// import { parse } from "path";
import { InputText } from "primereact/inputtext";
import ReactPlayer from "react-player";
import CryptoJS from 'crypto-js';

const EvaluacionExamen = () => {
  const aboutSection = useRef(null);
  const { configuraciones, perfil } = useAlumno();
  let { IdPersonaCurso } = useParams();
  let { idEvaluacion } = useParams();
  let { idUnidad } = useParams();
  const navigate = useNavigate();
  const [unidad, setUnidad] = useState(null);
  const [evaluacion, setEvaluacion] = useState(null);
  const [preguntaActual, setPreguntaActual] = useState(null);
  const [listaPreguntas, setListaPreguntas] = useState(null);
  const [preguntasPaginadas, setPreguntasPaginadas] = useState([]);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [isActive, setIsActive] = useState(false);
  const [paginaActual, setPaginaActual] = useState(1);
  const [numeroPaginas, setNumeroPaginas] = useState(1);
  const numeroPreguntasPagina = 5;
  const [listaAlternativas, setListaAlternativas] = useState(null);
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const [preguntasRespondidas, setPreguntasRespondidas] = useState([]);
  const [showAlerta, setShowAlerta] = useState(false);
  const [showResulados, setShowResulados] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resultadoExamen, setResultadoExamen] = useState(null);
  const [notaMinima, setNotaMinima] = useState(null);
  const [showDialogImage, setShowDialogImage] = useState(null);
  const [imagenRecurso, setImagenRecurso] = useState(null);
  const [videoRecurso, setVideoRecurso] = useState(null);
  const [showDialogMateriales, setShowDialogMateriales] = useState(false);
  const [listaLecciones, setListaLecciones] = useState(null);
  const [listaLeccionMaterial, setlistaLeccionMaterial] = useState(null);
  const [respuestasInput, setRespuestasInput] = useState({});
  const [idEvaluacionChange,setidEvaluacion]=useState(null)

  useEffect(() => {
    if (preguntasRespondidas.length > 0) {
    }
  }, [preguntasRespondidas]);
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const descargarMaterial = () => {
    setLoading(true);
    let jwt = window.localStorage.getItem("jwt");
    DescargarListaMaterialesUnidad({ jwt, idUnidad })
      .then((data) => {
        DescargarFromBase64(data, `Unidad${unidad.secuencia}`).setLoading(
          false
        );
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    const getLeccionesCursos = () => {
      let jwt = window.localStorage.getItem("jwt");
      ObtenerListaMaterialesUnidad({ jwt, idUnidad }).then((data) => {
        var agrupados = {}
        data.forEach(material => {
          if (!agrupados[material.idLeccion.toString()]) {
            agrupados[material.idLeccion.toString()] = [];
          }
          agrupados[material.idLeccion.toString()].push(material);
        });
        setListaLecciones(data);
        setlistaLeccionMaterial(agrupados);
      });
    };
    if (idUnidad) getLeccionesCursos();
  }, [idUnidad]);
  useEffect(() => {
    if (idUnidad && idEvaluacion && listaPreguntas) {
      let respondidasInicio = [];

      for (let i = 0; i < listaPreguntas.length; i++) {
        respondidasInicio.push(
          `${listaPreguntas[i].idPregunta}|null|${listaPreguntas[i].idPreguntaTipo}`
        );
      }
      setPreguntasRespondidas(respondidasInicio);
      sessionStorage.setItem(
        `respuestas_alumno`,
        idUnidad + ";" + idEvaluacion + ";" + respondidasInicio
      );
    }
  }, [idUnidad, idEvaluacion, listaPreguntas]);

  useEffect(() => {
    let interval = null;

    if (isActive) {
      interval = setInterval(() => {
        if (seconds > 0) {
          setSeconds(seconds - 1);
        } else {
          if (minutes === 0) {
            clearInterval(interval);
            //localStorage.removeItem("tiempoEvalaucion");
            localStorage.removeItem("502b0ebb62e2");
            handleEnviar()
            setIsActive(false);
          } else {
            //localStorage.setItem('tiempoEvalaucion', minutes - 1);
            localStorage.setItem('502b0ebb62e2', CryptoJS.AES.encrypt((minutes - 1).toString(), alphabet).toString());
            setMinutes(minutes - 1);
            setSeconds(59);
          }
        }
      }, 1000);
    } else if (!isActive && (minutes !== 0 || seconds !== 0)) {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [isActive, minutes, seconds]);
  useEffect(() => {
    if (idUnidad) {
      let jwt = window.localStorage.getItem("jwt");
      //let idUnidad = idCursoUsuario;
      BuscarUnidadID({ jwt, idUnidad }).then((data) => {
        setUnidad(data);
      });
    }
  }, [idUnidad]);

  useEffect(() => {
    if (idEvaluacion && idEvaluacion > 0) {
      let jwt = window.localStorage.getItem("jwt");
      let id = idEvaluacion;
      BuscarEvaluacionPorId({ jwt, id }).then((data) => {
        setEvaluacion(data);
      });
    }
  }, [idEvaluacion]);

  useEffect(() => {
    if (evaluacion) {
      if (evaluacion.nota !== null) {
        navigate("/Inicio/Dashboard",{replace:true});
      }
    }
  }, [evaluacion]);

  useEffect(() => {
    if (listaPreguntas) {
      setPreguntaActual(listaPreguntas[0]);
    }
  }, [listaPreguntas]);

  useEffect(() => {
    if (idUnidad) {
      let jwt = window.localStorage.getItem("jwt");
      /* if (perfil === null) {
        window.location.href = "/" + PrivateRoutes.HOME + "/Dashboard";
      } else { */
      ListarPreguntasPorUnidad({ jwt, idUnidad }).then((data) => {
        let preguntasAleatorias = [];
        let tempRespondidas = [];
        //var contadorPreguntas = data?.length >= 20? 20:10;
        var contadorPreguntas = 10;
        for (let i = 0; i < contadorPreguntas; i++) {
          // Generar un índice aleatorio dentro del rango de preguntas disponibles
          const indiceAleatorio = Math.floor(Math.random() * data.length);

          // Agregar la pregunta aleatoria a la lista de preguntas seleccionadas
          preguntasAleatorias.push(data.splice(indiceAleatorio, 1)[0]);

          //tempRespondidas.push(`${idPregunta}|${respuesta}|${tipoPregunta}`);
        }
        //setPreguntasRespondidas(tempRespondidas);

        let testTemp = preguntasAleatorias.map((pregunta, i) => {
          const nuevaPregunta = { ...pregunta };
          nuevaPregunta.correlativo = i + 1;
          // Modificar la propiedad 'edad'

          return nuevaPregunta;
        });
        let preguntasAleatoriasOrden = testTemp.sort(
          (a, b) => new Date(a.correlativo) - new Date(b.correlativo)
        );

        setListaPreguntas(preguntasAleatoriasOrden);

        let numePaginas = parseInt(preguntasAleatoriasOrden.length / 5);

        if (preguntasAleatoriasOrden.length <= 5) {
          numePaginas = 1;
        }
        setNumeroPaginas(numePaginas);
        let tempPaginadas = [];
        for (let index = 1; index <= numePaginas; index++) {
          tempPaginadas.push(
            preguntasAleatoriasOrden.slice(
              numeroPreguntasPagina * (index - 1),
              numeroPreguntasPagina * index
            )
          );
        }
        localStorage.setItem('preguntasAleatoriasOrden', JSON.stringify(preguntasAleatoriasOrden));
        setPreguntasPaginadas(tempPaginadas)

      });
      /* } */
    }
  }, [perfil, idUnidad]);

  useEffect(() => {
    if (idUnidad) {
      let jwt = window.localStorage.getItem("jwt");
      let id = idUnidad;
      ObtenerAlternativasPorUnidad({ jwt, id }).then((data) => {
        setListaAlternativas(data);
      });
    }
  }, [idUnidad]);

  useEffect(() => {
    if (configuraciones) {
      //var tiempoEvalaucion = localStorage.getItem('tiempoEvalaucion');
      var tiempoEvalaucion = localStorage.getItem('502b0ebb62e2')?CryptoJS.AES.decrypt(localStorage.getItem('502b0ebb62e2'),alphabet).toString(CryptoJS.enc.Utf8):null
      let tiempo = 0;
      if (tiempoEvalaucion == null) {
        tiempo = buscarConfiguracion(
          configuraciones,
          "TIEMPO_MAX_EVALUACION"
        );
      }
      else {
        tiempo = tiempoEvalaucion
      }
      //localStorage.setItem('tiempoEvalaucion', tiempo);
      localStorage.setItem('502b0ebb62e2',CryptoJS.AES.encrypt(tiempo, alphabet).toString());

      let notaMIn = buscarConfiguracion(configuraciones, "NOTA_MINIMA_APROB");
      setNotaMinima(notaMIn);
      if (tiempo.length > 0) {
        setIsActive(true);
        setMinutes(parseInt(tiempo));
        setSeconds(0);
      }
    }
  }, [configuraciones]);

  const handleEnviar = (e) => {
    //e.preventDefault();
    setLoading(true);
    let jwt = window.localStorage.getItem("jwt");
    let IdUnidad = idUnidad;

    let Respuestas = preguntasRespondidas;
    //let Respuestas = respondidas;
    let IdEvaluacion = idEvaluacion;
    let jsonExamen = JSON.stringify(
      {
        IdUnidad,
        IdEvaluacion,
        Respuestas,
        IdPersonaCurso
      },
      null,
      2
    );
    EvaluarExamen({ jsonExamen, jwt })
      .then((data) => {
        if(data == undefined){
          alert("Error al recibir evaluación");
        }
        
        //localStorage.removeItem("tiempoEvalaucion");
        localStorage.removeItem("502b0ebb62e2");
        localStorage.removeItem('clave');
        setLoading(false);
        setShowAlerta(false);
        if(data?.nota!=null){
          sessionStorage.removeItem("respuestas_alumno");// en el caso de obtener la evaluacion eliminar las respuestas para evitar la ejecucion
        }
        setResultadoExamen(data);
        if(idEvaluacion != data?.idEvaluacion){
          setidEvaluacion(data.idEvaluacion);
        }
      })
    .catch((error) => {
        console.log(error); 
        setLoading(false);
      });
  };

  useEffect(() => {
    if (resultadoExamen) {
      setShowResulados(true);
    }
  }, [resultadoExamen]);

  const paginacion = (data) => {
    return (
      <div className="flex align-items-center gap-4">
        <div
          className="flex align-items-center  paginacion-examen"
          style={{ gap: "10px" }}
        >
          {data.map((item, i) => {
            return (
              <div
                key={i}
                className={classNames(
                  "flex align-items-center justify-content-center font-bold text-xs eva-pregunta",
                  {
                    "pr-respondida":
                      preguntasRespondidas.length > 0 &&
                      preguntasRespondidas.find(
                        (x) =>
                          x.split("|")[0] === item.idPregunta.toString() &&
                          x.split("|")[1] !== "null"
                      ),
                  }
                )}
              >
                {i + 1}
              </div>
            );
          })}
        </div>
        <div>
          <p
            className="text-lg font-bold text-14-mobile"
            style={{ color: "#22A231", width: 50 }}
          >
            {String(minutes).padStart(2, "0")}:
            {String(seconds).padStart(2, "0")}
          </p>
        </div>
      </div>
    );
  };

  const obtenerPreguntasSinContestar = () => {
    let idsContestadas = preguntasRespondidas
      .filter((x) => x.split("|")[1] != "null")
      .map((item) => parseInt(item.split("|")[0]));
    if (listaPreguntas) {
      let idNoContestadas = listaPreguntas
        .filter((pregunta) => !idsContestadas.includes(pregunta.idPregunta))
        .map((pregunta) => pregunta.correlativo);
      return idNoContestadas.join("-");
    } else {
      return "";
    }
  };

  const contenidoAlerta = (
    <div style={{ paddingTop: 30 }}>
      <div
        className="font-bold"
        style={{ fontSize: "16px", paddingBottom: 36 }}
      >
        ¿Estás seguro que quieres enviar la evaluación?
      </div>

      {obtenerPreguntasSinContestar().length > 0 && (
        <>
          <div style={{ fontSize: "12px", paddingBottom: 18 }}>
            No has respondido la pregunta:
          </div>
          <div
            className="font-bold"
            style={{ fontSize: "18px", paddingBottom: 22 }}
          >
            {obtenerPreguntasSinContestar()}
          </div>
        </>
      )}
    </div>
  );
  const footerAlerta = (
    <div>
      <div style={{ marginBottom: 12 }}>
        <ButtonZegel
          label="Regresar a la evaluación"
          width="100%"
          color="primary"
          onClick={() => setShowAlerta(false)}
        ></ButtonZegel>
      </div>
      <div>
        <ButtonZegel
          label="Terminar y enviar"
          width="100%"
          color="secondary"
          onClick={(e) => handleEnviar(e, false)}
          loading={loading}
        ></ButtonZegel>
      </div>
    </div>
  );
  const obtenerMensaje = () => {
    let mensaje = "";
    if (resultadoExamen) {
      if (parseInt(resultadoExamen.nota) >= parseInt(notaMinima)) {
        if (parseInt(resultadoExamen.nota) === 20) {
          mensaje = "¡Felicitaciones! Obtuviste el máximo puntaje";
        } else {
          mensaje =
            "Te recomendamos ver tus resultados para saber qué lecciones necesitas reforzar. Además, cuentas con un segundo intento para mejorar tu nota.";
        }
      } else {
        mensaje =
          "Te recomendamos ver tus resultados para saber qué lecciones necesitas reforzar. Recuerda que al haber desaprobado los dos intentos, no obtendrás certificado del curso.";
      }
      return mensaje;
    } else {
      return "";
    }
  };

  const obtenerEstadoNota = () => {
    let aprobado = false;
    if (resultadoExamen) {
      if (parseInt(resultadoExamen.nota) >= parseInt(notaMinima)) {
        aprobado = true;
      } else {
        aprobado = false;
      }
      return aprobado;
    } else {
      return aprobado;
    }
  };
  const contenidoResult = (
    <div style={{ paddingTop: 30 }}>
      <div style={{ paddingBottom: 16 }}>
        Nota:{" "}
        <span
          className={classNames("resultado-examen", {
            aprobado: obtenerEstadoNota() === true,
            desaprobado: obtenerEstadoNota() === false,
          })}
        >
          {resultadoExamen && resultadoExamen.nota}/20
        </span>
      </div>
      <div style={{ paddingBottom: 23 }}>{obtenerMensaje()}</div>
    </div>
  );
  const contenidoMaterial = (
    <div style={{ paddingLeft: 50, paddingRight: 50, paddingTop: 40 }}>
      <div style={{ paddingBottom: 27 }}>
        <strong>Material de la unidad {unidad && unidad.secuencia}</strong>
      </div>      
      <div className="materiales-unidad">
      {listaLeccionMaterial && Object.keys(listaLeccionMaterial).map((idLeccion , i )=> (
          (listaLeccionMaterial[idLeccion].map((leccion, j) => {
            return (
              <div
                className="flex  w-full"
                key={i}
                style={{ border: "1px solid #707070" }}
              >
                <div
                  className="flex align-items-center"
                  style={{ padding: "15px 17px", width: "calc(100% - 50px)" }}
                >
                  <div
                    className="font-bold text-xs"
                    style={{ marginBottom: 4 }}
                  >
                    Lección {i + 1} {leccion.titulo}
                  </div>
                </div>
                <a href={leccion.link} target="_blank" rel="noreferrer">
                  <div
                    className=" flex align-items-center justify-content-center interna-material-download"
                    style={{
                      width: "70px",
                      height: "82px",
                    }}
                  >
                    <img
                      src={iconDownload}
                      width={"17.5px"}
                      height={"21px"}
                    ></img>
                  </div>
                </a>
              </div>
            );
          }))
      ))}
      </div>
    </div>
  );
  const footerMateriales = (
    <div
      className="flex"
      style={{ paddingLeft: 50, paddingRight: 50, paddingBottom: 40 }}
    >
      <div className="materiales-unidad">
      <ButtonZegel
        label="Regresar a la evaluación"
        color="secondary"
        onClick={() => setShowDialogMateriales(false)}
      ></ButtonZegel>

      <ButtonZegel
        label="Descargar todos"
        color="primary"
        onClick={() => descargarMaterial()}
        loading={loading}
      ></ButtonZegel>
      </div>
    </div>
  );

  const footerResultado = (
    <div>
      <div style={{ marginBottom: 12 }}>
        <Link
          to={`/Inicio/Evaluacion/Resultado/${IdPersonaCurso}/${idEvaluacionChange !== null ? idEvaluacionChange : idEvaluacion}/${idUnidad}`}
          replace
        >
          <ButtonZegel
            label="Ver resultados"
            width="100%"
            color="primary"
          //onClick={() => setShowAlerta(false)}
          ></ButtonZegel>
        </Link>
      </div>
      <div>
        <Link to={`/Inicio/CursoInterno/${IdPersonaCurso}`} replace>
          <ButtonZegel
            label="Ir a lecciones"
            width="100%"
            color="secondary"
          //onClick={() => handleEnviar(false)}
          //loading={loading}
          ></ButtonZegel>
        </Link>
      </div>
    </div>
  );

  const contenidoImage = (
    <div>
      {imagenRecurso && <img src={imagenRecurso}></img>}
      {videoRecurso && <ReactPlayer url={videoRecurso} controls={true} playing={true}></ReactPlayer>}
    </div>
  );

  const apilaRespuestas = (idPregunta, respuesta, tipoPregunta) => {
    let tempRespondidas = [...preguntasRespondidas];
    if (tempRespondidas.length === 0) {
      tempRespondidas.push(`${idPregunta}|${respuesta}|${tipoPregunta}`);
    } else {
      let index = tempRespondidas.findIndex(
        (x) => x.split("|")[0] === idPregunta.toString()
      );
      if (index > -1) {
        if (tipoPregunta === 1) {
          let indexAlt = tempRespondidas.findIndex(
            (x) => x.split("|")[1] === respuesta.toString()
          );
          if (indexAlt > -1) {
            //tempRespondidas.splice(indexAlt, 1);
            tempRespondidas[index] = `${idPregunta}|null|${tipoPregunta}`;
          } else {
            tempRespondidas[
              index
            ] = `${idPregunta}|${respuesta}|${tipoPregunta}`;
          }
        } else {
          if (respuesta.length === 0) {
            tempRespondidas[index] = `${idPregunta}|null|${tipoPregunta}`;
          } else {
            tempRespondidas[
              index
            ] = `${idPregunta}|${respuesta}|${tipoPregunta}`;
          }
        }
      } else {
        tempRespondidas.push(`${idPregunta}|${respuesta}|${tipoPregunta}`);
      }
    }

    setPreguntasRespondidas(tempRespondidas);
    sessionStorage.setItem(
      `respuestas_alumno`,
      idUnidad + ";" + idEvaluacion + ";" + tempRespondidas
    );
  };
  // useEffect(() => {
  //   if (respuestasInput && respuestasInput.length > 0)
  // }, [respuestasInput]);
  if (perfil === null) {
    return null;
  }
  const scrollDown = () => {
    window.scrollTo({
      top: aboutSection.current.offsetTop,
      behavior: "smooth"

    });


  };
  return (
    <div className="Evaluacion-examen" ref={aboutSection}>
      <DashboardNavBarEvaluacionProgreso
        titulo={`Evaluación - unidad ${unidad ? unidad.secuencia : ""}`}
        preguntas={
          listaPreguntas && preguntaActual ? paginacion(listaPreguntas) : <></>
        }
      />
      <div className="content-general-navigation align-items-start ">
        <div className="ex-descarga-material pt-4 w-full">
          <Link
            className="text-lg font-bold"
            style={{ color: "#404BD9" }}
            onClick={() => setShowDialogMateriales(true)}
          >
            Descarga aquí
          </Link>{" "}
          <span className="text-lg">
            el material de la Unidad {unidad && unidad.secuencia}
          </span>
        </div>
        <div className="ex-preguntas">
          {preguntasPaginadas &&
            preguntasPaginadas.length > 0 &&
            preguntasPaginadas[paginaActual - 1].map((pregunta, i) => {
              return (
                <div key={i} className="ex-pregunta-alernativa w-full mt-6">
                  <div
                    className="pregunta-item  pb-2 mb-2 font-bold"
                    style={{ fontSize: "16px" }}
                  >
                    {`${pregunta.correlativo}. ${pregunta.titulo}`}</div>
                  <div
                    className={classNames("body-pregunta", {
                      "pr-select": pregunta.idPreguntaTipo === 1 ? true : false,
                      "pr-input": pregunta.idPreguntaTipo === 2 ? true : false,
                    })}
                  >
                    {pregunta.idTipoRecurso === 2 &&
                      pregunta.recurso !== "" &&
                      pregunta.recurso !== null && (
                        <div className="" style={{ marginBottom: 20 }}>
                          <ButtonImage
                            label="Ver imagen"
                            icon={<img src={iconImage} height={19.5}></img>}
                            style={{ width: "199px" }}
                            onClick={() => {
                              setImagenRecurso(pregunta.recurso);
                              setShowDialogImage(true);
                            }}
                          ></ButtonImage>
                        </div>
                      )}

                    {pregunta.idTipoRecurso === 3 &&
                      pregunta.recurso !== "" &&
                      pregunta.recurso !== null && (
                        <div className="" style={{ marginBottom: 20 }}>
                          <ButtonImage
                            label="Ver video"
                            icon={<img src={iconImage} height={19.5}></img>}
                            style={{ width: "199px" }}
                            onClick={() => {
                              setVideoRecurso(pregunta.recurso);
                              setShowDialogImage(true);
                            }}
                          ></ButtonImage>
                        </div>
                      )}
                    {pregunta.idPreguntaTipo === 2 ? (
                      <div className="input-respuesta-container">
                        <span className="p-input-icon-right">
                          {/* <i><img src={closeCircle}></img></i> */}
                          <InputText
                            className="input-respuesta"
                            placeholder="Escribir respuesta"
                            value={respuestasInput[pregunta.idPregunta] || ""}
                            keyfilter={"pnum"}
                            /* Es posible q se requiera exlpicacion de la interpretacion del texto al evaluar*/
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              if (/^\d*$/g.test(inputValue)) {
                                setRespuestasInput((prevState) => ({
                                  ...prevState,
                                  [pregunta.idPregunta]: e.target.value,
                                }));
                                apilaRespuestas(
                                  pregunta.idPregunta,
                                  e.target.value,
                                  2
                                );
                              }
                            }}
                          ></InputText>
                        </span>
                      </div>
                    ) : pregunta.idTipoRecurso === 1 ? (
                      <div className="ex-alternativas-image">
                        {listaAlternativas &&
                          listaAlternativas
                            .filter((x) => x.idPregunta === pregunta.idPregunta)
                            .map((alt, j) => {
                              return (
                                <div
                                  key={j}
                                  className={classNames(
                                    "alternativas-image-item  mb-2",
                                    {
                                      "alt-seleccionada":
                                        preguntasRespondidas &&
                                        preguntasRespondidas.find(
                                          (x) =>
                                            x.split("|")[1] ===
                                            alt.idRespuesta.toString()
                                        ),
                                    }
                                  )}
                                  style={{ fontSize: 14, cursor: "pointer" }}
                                  onClick={() => {
                                    apilaRespuestas(
                                      pregunta.idPregunta,
                                      alt.idRespuesta,
                                      1
                                    );
                                    // let tempRespondidas = [
                                    //   ...preguntasRespondidas,
                                    // ];
                                    // if (tempRespondidas.length == 0) {
                                    //   tempRespondidas.push(
                                    //     `${pregunta.idPregunta}|${alt.idRespuesta}|1`
                                    //   );
                                    // } else {
                                    //   let index = tempRespondidas.findIndex(
                                    //     (x) =>
                                    //       x.split("|")[0] ===
                                    //       pregunta.idPregunta.toString()
                                    //   );
                                    //   if (index > -1) {
                                    //     let indexAlt = tempRespondidas.findIndex(
                                    //       (x) =>
                                    //         x.split("|")[1] ===
                                    //         alt.idRespuesta.toString()
                                    //     );
                                    //     if (indexAlt > -1) {
                                    //       tempRespondidas.splice(indexAlt, 1);
                                    //     } else {
                                    //       tempRespondidas[
                                    //         index
                                    //       ] = `${pregunta.idPregunta}|${alt.idRespuesta}|1`;
                                    //     }
                                    //   } else {
                                    //     tempRespondidas.push(
                                    //       `${pregunta.idPregunta}|${alt.idRespuesta}|1`
                                    //     );
                                    //   }
                                    // }

                                    // setPreguntasRespondidas(tempRespondidas);
                                    // localStorage.setItem(
                                    //   `respuestas_alumno`,
                                    //   idUnidad +
                                    //     ";" +
                                    //     idEvaluacion +
                                    //     ";" +
                                    //     tempRespondidas
                                    // );
                                  }}
                                >
                                  <div style={{ paddingBottom: 20 }}>
                                    <img src={alt.recurso}></img>
                                  </div>
                                  <div>
                                    <span className={"font-bold"}>
                                      {alphabet[j]}.{" "}
                                    </span>
                                    {alt.descripcion}
                                  </div>
                                </div>
                              );
                            })}
                      </div>
                    ) : (
                      <div className="ex-alternativas">
                        {listaAlternativas &&
                          listaAlternativas
                            .filter((x) => x.idPregunta === pregunta.idPregunta)
                            .map((alt, j) => {
                              return (
                                <div
                                  key={j}
                                  className={classNames(
                                    "alternativas-item  mb-2",
                                    {
                                      "alt-seleccionada":
                                        preguntasRespondidas &&
                                        preguntasRespondidas.find(
                                          (x) =>
                                            x.split("|")[1] ===
                                            alt.idRespuesta.toString()
                                        ),
                                    }
                                  )}
                                  style={{ fontSize: 14, cursor: "pointer" }}
                                  onClick={() => {
                                    apilaRespuestas(
                                      pregunta.idPregunta,
                                      alt.idRespuesta,
                                      1
                                    );

                                    // let tempRespondidas = [
                                    //   ...preguntasRespondidas,
                                    // ];
                                    // if (tempRespondidas.length == 0) {
                                    //   tempRespondidas.push(
                                    //     `${pregunta.idPregunta}|${alt.idRespuesta}|1`
                                    //   );
                                    // } else {
                                    //   let index = tempRespondidas.findIndex(
                                    //     (x) =>
                                    //       x.split("|")[0] ===
                                    //       pregunta.idPregunta.toString()
                                    //   );
                                    //   if (index > -1) {
                                    //     let indexAlt = tempRespondidas.findIndex(
                                    //       (x) =>
                                    //         x.split("|")[1] ===
                                    //         alt.idRespuesta.toString()
                                    //     );
                                    //     if (indexAlt > -1) {
                                    //       tempRespondidas.splice(indexAlt, 1);
                                    //     } else {
                                    //       tempRespondidas[
                                    //         index
                                    //       ] = `${pregunta.idPregunta}|${alt.idRespuesta}|1`;
                                    //     }
                                    //   } else {
                                    //     tempRespondidas.push(
                                    //       `${pregunta.idPregunta}|${alt.idRespuesta}|1`
                                    //     );
                                    //   }
                                    // }

                                    // setPreguntasRespondidas(tempRespondidas);
                                    // localStorage.setItem(
                                    //   `respuestas_alumno`,
                                    //   idUnidad +
                                    //     ";" +
                                    //     idEvaluacion +
                                    //     ";" +
                                    //     tempRespondidas
                                    // );
                                  }}
                                >
                                  <div className="contenido-alternativa">
                                    <span>
                                      {alphabet[j]}.
                                    </span>
                                    <span>
                                      {alt.descripcion}
                                    </span>
                                  </div>


                                </div>
                              );
                            })}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
        </div>
        <div
          className="ex-footer flex align-items-center  justify-content-end paddingPaginacion"
          style={{ marginTop: 60, marginBottom: 60 }}
        >
          <div
            className="flex align-items-center gap-3 justify-content-end"
            style={{ width: "326px" }}
          >
            <div>
              <span>
                {paginaActual} de {numeroPaginas}{" "}
              </span>
            </div>
            {paginaActual > 1 && (
              <ButtonZegel
                icon="pi pi-angle-left"
                width="50px"
                color="primary"
                onClick={() => {
                  setPaginaActual(paginaActual - 1);
                  scrollDown();
                }}
              ></ButtonZegel>
            )}
            {paginaActual < numeroPaginas && (
              <ButtonZegel
                icon="pi pi-angle-right"
                width="50px"
                color="primary"
                onClick={() => {
                  setPaginaActual(paginaActual + 1);
                  scrollDown();
                }}
              ></ButtonZegel>
            )}
            {paginaActual == numeroPaginas && (
              <ButtonZegel
                label="Finalizar y enviar"
                width="194px"
                color="primary"
                onClick={() => setShowAlerta(true)}
              ></ButtonZegel>
            )}
          </div>
        </div>
      </div>

      <FooterInterno />
      <DialogZegel
        header=""
        visible={showAlerta}
        width="30vw"
        onHide={() => setShowAlerta(false)}
        footer={footerAlerta}
        contenido={contenidoAlerta}
        textAlign="center"
        showHeader={false}
        contentStyle={{ paddingBottom: 0 }}
      ></DialogZegel>
      {resultadoExamen && (
        <DialogZegel
          header=""
          visible={showResulados}
          width="30vw"
          onHide={() => setShowResulados(false)}
          footer={footerResultado}
          contenido={contenidoResult}
          textAlign="center"
          showHeader={false}
          contentStyle={{ paddingBottom: 0 }}
        ></DialogZegel>
      )}

      <DialogImage
        visible={showDialogImage}
        onHide={() => {
          setImagenRecurso(null);
          setVideoRecurso(null);
          setShowDialogImage(false);
        }}
        contenido={contenidoImage}
      ></DialogImage>

      {showDialogMateriales && unidad && listaLecciones && (
        <DialogZegel
          header=""
          visible={showDialogMateriales}
          width="70%"
          onHide={() => setShowDialogMateriales(false)}
          footer={footerMateriales}
          contenido={contenidoMaterial}
          textAlign="center"
          showHeader={false}
        //padding={55}
        ></DialogZegel>
      )}
    </div>
  );
};

export default EvaluacionExamen;
